import SectionWrapper from '@/common/SectionWrapper';
import VehicleCarousel from '@/common/VehicleCarousel';
import { CarouselTileWrapper } from '@/common/VehicleCarousel/CarouselTileWrapper';
import LoadingVehicleCarousel from '@/common/VehicleCarousel/LoadingVehicleCarousel';
import VehicleTile from '@/srp/VehicleTile';
import useGetSrpRecentlyViewed from '~/hooks/srp/services/useGetSrpRecentlyViewed';
import useGetSrpVehicleAvailability from '~/hooks/srp/services/useGetSrpVehicleAvailability';

export default function RecentlyViewedCarousel() {
  const { hasError, isLoaded, vehicles } = useGetSrpRecentlyViewed();

  useGetSrpVehicleAvailability(vehicles);

  if (!isLoaded) {
    return (
      <LoadingVehicleCarousel
        hasBottomBorder
        hasGutterPadding={false}
        tileCount={3}
      />
    );
  }

  if (hasError || vehicles.length === 0) return null;

  return (
    <SectionWrapper
      analyticsSection="Recently Viewed"
      eventName="Free Text No Results Section"
      hasBackground={false}
    >
      <VehicleCarousel
        hasBottomBorder
        hasGutterPadding={false}
        headerTitle="Recently viewed"
      >
        {vehicles.map(vehicle => (
          <CarouselTileWrapper key={vehicle.vehicleId}>
            <VehicleTile
              showMoreDetailsModal={false}
              showTermsTooltip={false}
              vehicle={vehicle}
            />
          </CarouselTileWrapper>
        ))}
      </VehicleCarousel>
    </SectionWrapper>
  );
}
